import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileWaveform,
  faFileCircleCheck,
  faTruckLoading,
} from "@fortawesome/free-solid-svg-icons";
import resultsService from "../../../Services/resultsService";

function CardioRIcon({ reportId, ifFinal }) {
  const [pdfString, setPdfString] = useState();

  const printReport = async () => {
    return await resultsService.getCardioRFile(ifFinal, reportId).then((p) => {
      return `data:application/pdf;base64,${p.data}`;
    });
  };

  const downloadPDF = async () => {
    const linkSource = await printReport();
    const downloadLink = document.createElement("a");

    downloadLink.href = linkSource;
    downloadLink.download = `CardioR_${reportId.slice(0, 7)}${
      ifFinal ? "_Final" : ""
    }`;
    downloadLink.click();
  };
  return (
    <div
      onClick={async () => {
        await downloadPDF();
      }}
      style={{ cursor: "pointer" }}
    >
      <FontAwesomeIcon
        icon={ifFinal ? faFileCircleCheck : faFileWaveform}
        style={{ fontSize: 40 }}
      />
    </div>
  );
}

export default CardioRIcon;
